import { serializeDates, toDate, } from '@utils/object.utils';
var isInMap = function (data) {
    return typeof data === 'object' &&
        typeof data.in === 'function';
};
var ɵ0 = isInMap;
var isOutMap = function (data) {
    return typeof data === 'object' &&
        typeof data.out === 'function';
};
var ɵ1 = isOutMap;
var Mapper = /** @class */ (function () {
    function Mapper() {
        var _this = this;
        this.mapper = {};
        this._toDto = function (data, nestedMapper, source) {
            var mapped = {};
            var map = nestedMapper || _this.mapper;
            source = source || data || {};
            for (var _i = 0, _a = Object.keys(map); _i < _a.length; _i++) {
                var key = _a[_i];
                var mapKey = map[key];
                if (mapKey instanceof Array) { // map nested array
                    var property = mapKey[0];
                    var nestedData = data[property];
                    if (nestedData instanceof Array) {
                        mapped[key] = [];
                        for (var _b = 0, nestedData_1 = nestedData; _b < nestedData_1.length; _b++) {
                            var entry = nestedData_1[_b];
                            if (entry) {
                                mapped[key].push(_this._toDto(entry, mapKey[1], source));
                            }
                        }
                    }
                    else {
                        // map nested object
                        mapped[key] = nestedData ? _this._toDto(nestedData, mapKey[1], source) : undefined;
                    }
                }
                else if (typeof mapKey === 'function') {
                    mapped[key] = mapKey(mapped, source);
                }
                else if (isInMap(mapKey)) {
                    if (Array.isArray(mapKey.property)) {
                        mapped[key] = mapKey.in(data, mapped, source);
                    }
                    else {
                        mapped[key] = mapKey.in(data[mapKey.property], mapped, source);
                    }
                }
                else {
                    // map property
                    mapped[key] = data[mapKey.property || mapKey];
                }
            }
            return toDate(mapped);
        };
        this._toPoco = function (data, nestedMapper) {
            var serverData = {};
            var map = nestedMapper || _this.mapper;
            var _loop_1 = function (key) {
                var mapKey = map[key];
                if (mapKey instanceof Array) { // map nested array
                    var property = mapKey[0];
                    var nestedData = data[key];
                    if (nestedData instanceof Array) {
                        serverData[property] = [];
                        for (var _i = 0, nestedData_2 = nestedData; _i < nestedData_2.length; _i++) {
                            var entry = nestedData_2[_i];
                            if (entry) {
                                serverData[property].push(_this._toPoco(entry, mapKey[1]));
                            }
                        }
                    }
                    else { // map nested object
                        serverData[property] = nestedData ? _this._toPoco(nestedData, mapKey[1]) : undefined;
                    }
                }
                else if (isOutMap(mapKey)) {
                    var config = mapKey;
                    if (!Array.isArray(config.property)) {
                        serverData[config.property] = !config.out ?
                            data[key] :
                            config.out(data);
                    }
                    else {
                        // we expect here to have all the properties provided by the out function
                        var mapped_1 = config.out && config.out(data);
                        config.property.forEach(function (mappedSubKey) {
                            if (mapped_1 && mapped_1[mappedSubKey] != null) {
                                serverData[mappedSubKey] = mapped_1[mappedSubKey];
                            }
                        });
                    }
                }
                else if (typeof mapKey === 'string') { // map property
                    serverData[mapKey] = data[key];
                }
            };
            for (var _i = 0, _a = Object.keys(map); _i < _a.length; _i++) {
                var key = _a[_i];
                _loop_1(key);
            }
            return serializeDates(serverData);
        };
    }
    return Mapper;
}());
export { Mapper };
export { ɵ0, ɵ1 };
